var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190 48",
    style: {
      enableBackground: "new 0 0 190 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/2000/svg",
    type: "text/css"
  }, ".st0{fill:#D40F7D;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2,21.2c-1.4-9.8-9.8-17.4-20-17.4c-2.7,0-5.2,0.5-7.5,1.5L40.2,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.7,42.8c2.3,0.9,4.9,1.5,7.6,1.5c10.2,0,18.6-7.6,20-17.4L12.7,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,8.1C3,11.8,0,17.5,0,24c0,6.5,3,12.2,7.8,15.9V8.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.9,18.2v13.9h-2.8V18.2h-5.5v-2.3h13.8v2.3H60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3,24.6c0,3.3,2.8,5.5,5.7,5.5c1.9,0,4.5-0.9,5.3-1.5v2.8c-1.2,0.4-3,1-5.4,1c-5.7,0-8.6-3.5-8.6-8.7    c0-4.8,3.3-8.2,7.7-8.2c4.9,0,7.3,3.5,7.3,8v1H69.3z M74,17.8c-2.9,0-4.6,2.5-4.7,4.7h9.1C78.4,20,76.7,17.8,74,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3,32.1V18.2h-6v4.6c0,4.1-0.3,9.5-5,9.5c-0.6,0-1.4-0.1-1.7-0.2v-2.4c0.2,0.1,1,0.2,1.5,0.2c2,0,2.4-2.2,2.4-9.3v-4.7    h11.5v16.2H94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.3,24.6c0,3.3,2.8,5.5,5.7,5.5c1.9,0,4.5-0.9,5.3-1.5v2.8c-1.2,0.4-3,1-5.4,1c-5.7,0-8.6-3.5-8.6-8.7    c0-4.8,3.3-8.2,7.7-8.2c4.9,0,7.3,3.5,7.3,8v1H102.3z M107,17.8c-2.9,0-4.6,2.5-4.7,4.7h9.1C111.4,20,109.7,17.8,107,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.6,32.1V15.9h2.8v7.4h0.1l7.2-7.4h3.5l-7.6,7.5l8.5,8.6h-3.6l-8-8.4h-0.1v8.4H116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.8,32.1v-2.2h-0.1c-1.1,1.1-2.7,2.6-5,2.6c-3.7,0-5.8-2-5.8-5.1c0-4.5,4.9-5.4,7.1-5.4c1.6,0,3,0.4,3.5,0.6v-1.2    c0-2.4-1.2-3.6-3.9-3.6c-2.3,0-3.8,1-4.8,1.9v-2.4c0.7-0.5,2.7-1.8,5.2-1.8c4.5,0,6.3,2.2,6.3,6.6v10H141.8z M141.5,24.6    c-0.4-0.2-1.5-0.6-2.6-0.6c-1.4,0-5,0.3-5,3.3c0,1.8,1.6,2.8,3.1,2.8c1.5,0,3.5-1,4.6-2.2V24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,32.5c-2.1,0-4.2-1.2-5.3-2.5h-0.1v7.5h-2.8V15.9h2.6v2.3h0.1c1-1.1,2.7-2.7,5.4-2.7c4.6,0,7.9,3.4,7.9,8.2    C163.1,28.6,160,32.5,155.3,32.5z M154.9,17.8c-3.1,0-4.1,1.6-5,2.9v6.4c0.9,1.5,2.5,3.1,5,3.1c3.3,0,5.3-2.7,5.3-6.2    C160.1,20.6,158.2,17.8,154.9,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3,18.2v13.9h-2.8V18.2H163v-2.3h13.8v2.3H171.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5,32.1v-2.2h-0.1c-1.1,1.1-2.7,2.6-5,2.6c-3.7,0-5.8-2-5.8-5.1c0-4.5,4.9-5.4,7.1-5.4c1.6,0,3,0.4,3.5,0.6v-1.2    c0-2.4-1.2-3.6-3.9-3.6c-2.3,0-3.8,1-4.8,1.9v-2.4c0.7-0.5,2.7-1.8,5.2-1.8c4.5,0,6.3,2.2,6.3,6.6v10H187.5z M187.2,24.6    c-0.4-0.2-1.5-0.6-2.6-0.6c-1.4,0-5,0.3-5,3.3c0,1.8,1.6,2.8,3.1,2.8c1.5,0,3.5-1,4.6-2.2V24.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTv);
export default __webpack_public_path__ + "static/media/logo-tv.d2ae6c7d1f71c394904fe4e046708955.svg";
export { ForwardRef as ReactComponent };